import compileSymbols from '~/utils/compileSymbols';

var types = ['CONFIRM', 'DISMISS', 'ERROR', 'SUCCESS', 'PROMPT'];

export default compileSymbols(types, 'notification');
